export const CONNECT_TABS = ['targets', 'map', 'campaigns'] as const;
export type ConnectTab = (typeof CONNECT_TABS)[number];
